import http from "../http-common";

const getAll = () => {
  return http.get("/survey-datas-status");
};

export const surveyDatasStatus = {
  getAll,
};
